const niches = {
	slimming: 'Slimming',
	joints: 'Joints',
	hypertension: 'Hypertension',
	parasites: 'Parasites',
	diabetes: 'Diabetes',
	fungus: 'Fungus',
	smoking: 'Smoking',
	breast_augmentation: 'Breast augmentation',
	potency: 'Potency',
	urination: 'Urination',
	amulets: 'Amulets',
	immunity: 'Immunity',
	psoriasis: 'Psoriasis',
	papillomas: 'Papillomas',
	vision: 'Vision',
	prostatitis: 'Prostatitis',
	rejuvenation: 'Rejuvenation',
	hair: 'Hair',
	varicose_veins: 'Varicose veins',
	other: 'Other'
};

const locale = {
	ru: {
		slimming: 'Похудение',
		joints: 'Суставы',
		hypertension: 'Гипертония',
		parasites: 'Паразиты',
		diabetes: 'Диабет',
		fungus: 'Грибок',
		smoking: 'Курение',
		breast_augmentation: 'Увеличение груди',
		potency: 'Потенция',
		urination: 'Мочеиспускание',
		amulets: 'Амулеты',
		immunity: 'Иммунитет',
		psoriasis: 'Псориаз',
		papillomas: 'Папиломы',
		vision: 'Зрение',
		prostatitis: 'Простатит',
		rejuvenation: 'Омоложение',
		hair: 'Волосы',
		varicose_veins: 'Варикоз',
		other: 'Другое'
	},
	en: niches,
	uk: niches,
	de: niches,
	vi: niches,
	th: niches
};

module.exports = {
	enum: niches,
	locale
};


// WEBPACK FOOTER //
// ./enums/niches.js